import esriConfig from "@arcgis/core/config";
import React, { useEffect } from "react";
import { useGate, useStore } from "effector-react";
import {
  $isPrivateMapSettingsLoading,
  $privateMapSettings,
} from "src/screens/protected/create-report-screen/model";
import {
  $isMapSettingsLoaded,
  $publicArcgisSettings,
} from "src/screens/public/home-screen/model";

import { BrowserRouter, RoutesWrapper } from "src/shared/library/router";

import { $isLoggedIn, UserGate } from "./entities/user/model";
import { Notifications } from "./entities/notifications/ui";
import Layout from "./shared/layout";
import { setToken } from "./shared/api";
import { DefaultRoutes } from "./routes";

import "./css/index.scss";

function App() {
  useGate(UserGate);

  const isLoggedIn = useStore($isLoggedIn);
  const isPublicArcgisSettingsLoaded = useStore($isMapSettingsLoaded);
  const publicSettings = useStore($publicArcgisSettings);
  const privateSettings = useStore($privateMapSettings);
  const isPrivateSettingsLoading = useStore($isPrivateMapSettingsLoading);

  useEffect(() => {
    if (isLoggedIn) {
      const token = JSON.parse(window.sessionStorage.getItem("token")!);
      setToken(token!);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isPublicArcgisSettingsLoaded) {
      esriConfig.portalUrl = publicSettings[0].portal;
    }
  }, [isPublicArcgisSettingsLoaded, publicSettings]);

  useEffect(() => {
    if (!isPrivateSettingsLoading && privateSettings) {
      esriConfig.apiKey = privateSettings.key;
    }
  }, [privateSettings, isPrivateSettingsLoading]);

  return (
    <BrowserRouter basename="/">
      {isPublicArcgisSettingsLoaded && (
        <Layout>
          <RoutesWrapper>
            <DefaultRoutes />
          </RoutesWrapper>
          <Notifications />
        </Layout>
      )}
    </BrowserRouter>
  );
}

export default App;
